import {
  buildSearchFilter,
  buildSearchUrl,
  getSearchTermFromLocation,
  SEARCH_PAGE_SIZE,
} from "../../utils/searchUtils";
import {
  formatPostDate,
  getPlainExcerpt,
  getPostTypeLabel,
} from "../Members/memberUtils";

export {
  buildSearchFilter,
  buildSearchUrl,
  getSearchTermFromLocation,
  SEARCH_PAGE_SIZE,
};

export const getSearchResultTypeLabel = (post) => {
  if (post?.educationTopics?.length) {
    return "Education";
  }
  return getPostTypeLabel(post);
};

export const getSearchExcerpt = (post, maxLength = 200) => {
  const plain = getPlainExcerpt(post?.excerpt || post?.content || "");
  if (!plain) return "";
  if (plain.length <= maxLength) return plain;
  return `${plain.slice(0, maxLength).trim()}…`;
};

export { formatPostDate };
